import axios from "axios";
import { store } from "../store";

const axiosRequestwa = axios.create({
  // baseURL: "http://65.1.165.90/api/v1",
  baseURL: "https://wapi.puripolymers.com/api/v1",
});

axiosRequestwa.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth.token;
  config.params = config.params || {};
  config.headers["x-auth-token"] = token;
  return config;
});

export default axiosRequestwa;
